import styled from 'styled-components';
import {
  SYS_BREAKPOINT_MD,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_SM,
} from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';
import { IconButton } from '@oneaudi/unified-web-components';
import { SYS_SPACE_RELATIVE_XL } from '@oneaudi/unified-web-alpha-common';

export const CountAndSortContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  align-items: flex-start;
  margin-bottom: ${dynamicStylingHelper(SYS_SPACE_RELATIVE_LG, SYS_SPACE_RELATIVE_XL)};
  row-gap: ${SYS_SPACE_RELATIVE_SM};
  flex-direction: column;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const CountAndHeadlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${SYS_SPACE_RELATIVE_SM};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    align-items: center;
  }
`;
export const TopHeadlineContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  column-gap: ${SYS_SPACE_RELATIVE_SM};
`;

export const BottomRowContainer = styled.div`
  display: flex;
  ${dynamicStyling({ alpha: `justify-content: space-between` })};
  align-items: ${dynamicStylingHelper('center', 'flex-end')};
  width: 100%;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: unset;
  }
`;

export const StyledIconButton = styled(IconButton)`
  display: flex;
  justify-content: end;
`;

export const SortContainer = styled.div`
  display: inline-flex;
  align-items: ${dynamicStylingHelper('center', 'flex-end')};
  justify-content: flex-end;
  width: ${dynamicStylingHelper('unset', '100%')};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: unset;
  }

  & select {
    margin-top: unset;
    cursor: pointer;
  }

  & hr {
    position: unset;
  }

  & svg {
    ${dynamicStylingHelper('top: 20%')};
  }

  *:not(select) {
    min-height: unset;
  }

  ${dynamicStylingHelper(`
    margin-right: -12px;
    gap: 4px;
   `)}
`;

export const StyledCount = styled.div`
  & p {
    ${dynamicStylingHelper(`color: ${SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT}`)};
  }
`;
